module.exports = require("./ks-IN.js");